import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import helpers from "@/utils/helpers";
import Download from '../Download';
import { getDataConsultSoatPrint } from "@/redux/actions/consultAction";
import {
    MARKING_EVENT_TRACK_METADATA,
} from "@/consts/markingsConst";
import BackStep from '@/components/common/backStep';
import Title from '@/components/title';
import { RideButton, RideGlRight, RideTag } from '@rimac-seguros/ride-system-components';

import './styles.scss';

const Details = (props) => {

    const { client, nameLink, urlLink, children, consultSoat } = props;
    const { startDate, endDate, plateFormat, statusSOAT, urlConstElect, company } = consultSoat;

    const [ variant, setVariant ] = useState('');
    const [ nameText, setNameText ] = useState('');

    const isFuturePolicy = statusSOAT === 'FUTURO';
    
    useEffect(() => {
        if (statusSOAT !== undefined) statusText(statusSOAT);
    }, [statusSOAT])

    useEffect(() => {
        if (client && nameText) {
            helpers.getTagMetadata('Consulta SOAT - Usuario', `Cliente ${company}`, MARKING_EVENT_TRACK_METADATA);
            helpers.getTagMetadata('Consulta SOAT - Estado Póliza', `SOAT ${nameText}`, MARKING_EVENT_TRACK_METADATA);
        }
    }, [client, nameText])

    const convertDate = (date) => {
        if (!date) return '';
        return date ? helpers.convertirFormateIIFecha(date) : ''
    }

    const statusText = (soat) => {
        let text, variant;
        switch (soat) {
            case 'VIGENTE':
                variant = 'success';
                text = 'vigente'
                break;

            case 'POR_VENCER':
                variant = 'warning';
                text = 'por vencer';
                break;
            case 'VENCIDO':
                variant = 'critical';
                text = 'vencido'
                break;
            case 'FUTURO':
                variant = 'neutral';
                text = 'futuro'
                break;

            default:
                variant = '';
                text = ''
        };
        setVariant(variant)
        setNameText(text)
    };

    const handleMarket = () => {
        helpers.setActionTag({
            group: 'Consulta SOAT',
            category: 'Resultado',
            action: 'No cliente',
            label: 'Volver a consulta'
        });
    }

    return (
        <>
            <div className="validity-details__content">
                {children}
                {client && <BackStep {...props} />}
                <Title {...props} />
                {client && 
                    <>
                        <div className="validity-details__detail">
                            {nameText &&
                                <RideTag
                                    text={`SOAT ${nameText}`}
                                    case={variant}
                                    size="small"
                                    className="mb-ride-gl-spacing-xlarge"
                                />
                            }
                            <h4 className="validity-details__title">
                                {`${isFuturePolicy ? 'Inicio de vigencia:' : 'Fin de vigencia:'}`} <span>{convertDate(isFuturePolicy ? startDate : endDate)}</span>
                            </h4>
                            <p className="validity-details__text v2">Placa: <span>{plateFormat}</span></p>
                        </div>
                        {urlConstElect &&
                            <Download
                                data = {consultSoat}
                                props = {props}
                            />
                        }
                    </>
                }
                {!client &&
                    <div className="flex items-start my-ride-gl-spacing-2xlarge">
                        <RideButton
                            text={nameLink}
                            variant="text-primary"
                            glyph={<RideGlRight size="small" />}
                            glyphPosition="right"
                            size="large"
                            onClick={handleMarket}
                            href={urlLink}
                        />
                    </div>
                }
            </div>
        </>
    )
}

const mapStateToProps = ({ consultReducer }) => {
    return {
        consultSoat: consultReducer,
    };
};

const mapDsipatchToProps = (dispatch) => {
    return {
        getDataConsultSoatPrint: (data) => dispatch(getDataConsultSoatPrint(data)),
    };
};

const DetailsR = connect(mapStateToProps, mapDsipatchToProps)(Details);


export default DetailsR;